module.exports = require("ramda/src/isEmpty");